<template>
    <!-- Inizio footer -->
<footer class="Footer">
    <div class="TopSwitch"><a href="javascript:void(0)" @click="this.goTop()"><img src="/images/TopSwitchIcon.png" srcset="/images/TopSwitchIconRetina.png 2x" alt=""/></a></div>
    <div class="Container">
        <div class="Box">
            <div class="FooterLogoBox">
                <div class="FooterLogo"><a href="/" title=""><img src="/images/FooterLogo.png" srcset="/images/FooterLogoRetina.png 2x" alt=""/></a></div>
                <address class="FooterAddress">
                    <div class="Editor">
                        Cressi sub S.P.A.<br>
                        Via G. Adamoli 501,<br>
                        16165 Genova - Italy<br>
                        P.IVA IT00260910104<br>
                    </div>
                </address>
                <div class="FooterSocialMenu">
                    <ul>
                        <li><a target="_blank" href="https://www.facebook.com/cressigear" title=""><img src="/images/social/FacebookIcon.png" srcset="/images/social/FacebookIconRetina.png 2x" alt=""/></a></li>
                        <li><a target="_blank" href="https://www.youtube.com/user/CressiVideo" title=""><img src="/images/social/YoutubeIcon.png" srcset="/images/social/YoutubeIconRetina.png 2x" alt=""/></a></li>
                        <li><a target="_blank" href="https://www.instagram.com/cressi1946_italia/" title=""><img src="/images/social/InstagramIcon.png" srcset="/images/social/InstagramIconRetina.png 2x" alt=""/></a></li>
                    </ul>
                </div>
            </div>
            <div class="FooterMenuBox">
                <div class="FooterMenu">
                    <span>{{ this.risorse["Azienda"] }}</span>
                    <ul>
                        <li v-for="link in this.linkFooter1" :key="link.Id">
                            <router-link  :to="'/home/pages/'+link.Permalink">{{link.Etichetta}}</router-link>
                        </li>
                    </ul>
                </div>
                <div class="FooterMenu">
                    <span>Customer Service</span>
                    <ul>
                        <li v-for="link in this.linkFooter2" :key="link.Id">
                            <router-link  :to="'/home/pages/'+link.Permalink">{{link.Etichetta}}</router-link>
                        </li>
                    </ul>
                </div>
                <!-- <div class="FooterMenu">
                    <span>Footer 3</span>
                    <ul>
                        <li v-for="link in this.linkFooter3" :key="link.Id">
                            <router-link  :to="'/home/pages/'+link.Permalink">{{link.Etichetta}}</router-link>
                        </li>
                    </ul>
                </div> -->
            </div>
            <div class="FooterSubscribeBox">
                <div class="FooterSubscribeTitle">Newsletter</div>
                <div class="FooterSubscribeText">{{ this.risorse["NewsletterText"] }}</div>
                <div class="Form">
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputText">
                            <div class="Field"><input type="email" v-model="this.emailNewsletter" :placeholder="this.risorse['TuaEmail']"/></div>
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide FormCheckBox">
                            <div class="Label" v-html="this.risorse['PrivacyText']">
                            </div>
                            <div class="Field"><input type="checkbox" v-model="this.privacyChecked"  value="" /><label for="" class="checkmark"></label></div>
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputButton">
                            <div class="Field Button CustomColor"><a href="javascript:void(0)" @click="this.subscribeNewsletter">{{ this.risorse["Iscriviti"] }}</a></div>
                            <p class="NewsletterMsg" v-show="this.showNewslettersMsg">{{this.newsletterMsg}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<!-- Fine footer --><!-- Attenzione: l'ultima riga deve esserci! -->
</template>
<script>

import moment from "moment"
import MenuService from '@/services/menu.service.js';
import NewsletterService from '@/services/newsletter.service.js';
import Menu from '@/models/Menu.model.js';
import {EmailMixin, risorseMixin} from "@/mixin.js";
import IscrizioneNewsletter from "@/models/IscrizioneNewsletter.model.js";

export default {
    name: "Footer",
    data(){
        return {
            linkFooter1: [],
            linkFooter2: [],
            linkFooter3: [],
            privacyChecked: false,
            emailNewsletter: "",
            showNewslettersMsg: false,
            newsletterMsg: ""
        }
    },
    mixins: [EmailMixin, risorseMixin],
    methods: {
        goTop: function(){
            window.scrollTo(0, 0);
        },
        subscribeNewsletter: function(){
            this.resetMsgNewsletter();
            if(!this.privacyChecked){
                this.newsletterMsg = this.risorse["NewsPriMsg"];
                this.showNewslettersMsg = true;
                window.setTimeout(this.resetMsgNewsletter, 4000);
            }
            else if(!this.validateEmail(this.emailNewsletter)){
                this.newsletterMsg = this.risorse["NewsValidEmail"];
                this.showNewslettersMsg = true;
                window.setTimeout(this.resetMsgNewsletter, 4000);
            } 
            else{
                let iscrizione = new IscrizioneNewsletter();
                iscrizione.CodiceCliente = this.$store.getters.getAnagraficaAzienda.CodiceCliente;
                iscrizione.EmailIscrizione = this.emailNewsletter;
                iscrizione.DataRichiestaIscrizione = moment().format("YYYY-MM-DD HH:mm:ss");
                iscrizione.PrivacyPolicy = this.privacyChecked ? 1 : 0;
                NewsletterService. subscribeNewsletter(this.$store.getters.getToken, iscrizione).then(
                    (data) => {
                        if(!data){
                            this.$router.push("/")
                        }
                        else{
                            if(data.Status){
                                this.newsletterMsg = this.risorse["NewsOk"];
                                this.privacyChecked = false;
                                this.emailNewsletter = "";
                            }
                            else{
                                this.newsletterMsg = this.risorse["NewsEmailEsiste"];
                            }
                            this.showNewslettersMsg = true;
                            window.setTimeout(this.resetMsgNewsletter, 4000);
                        }
                    }
                ).catch(
                    (err) => {console.log(err)}
                )
            }
        },
        resetMsgNewsletter: function(){
            this.showNewslettersMsg = false;
            this.newsletterMsg = "";
        },
        getFooterMenu(tipoMenu){
            MenuService.getMenuByTipo(this.$store.getters.getToken, tipoMenu, this.$store.getters.getLingua, "B2B").then(
                (data) => {
                    if(!data){
                        this.$router.push("/")
                    }
                    else{
                        let menu = data.map(m => {
                            let link = new Menu();
                            return Object.assign(link, m);
                        });
                        if(tipoMenu == "FOOTER1")this.linkFooter1 = menu;
                        if(tipoMenu == "FOOTER2")this.linkFooter2 = menu;
                        if(tipoMenu == "FOOTER3")this.linkFooter3 = menu;
                    }
                }
            ).catch(
                (err) => {console.log(err)}
            )
        }
    },
    mounted: function(){
        this.getFooterMenu("FOOTER1");
        this.getFooterMenu("FOOTER2");
        this.getFooterMenu("FOOTER3");
    }
}
</script>
<style>
.NewsletterMsg{
    color: #ff0000;
    margin-top:20px;
    font-size: 13px;
}
</style>